import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './../../components/card/card.jsx';
import { Icon } from '@iconify/react';

function PagesOrders() {
	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<ul className="breadcrumb">
						<li className="breadcrumb-item"><a href="#/">PAGES</a></li>
						<li className="breadcrumb-item active">ORDERS</li>
					</ul>
					<h1 className="page-header mb-0">Orders</h1>
				</div>
				
				<div className="ms-auto">
					<a href="#/" className="btn btn-theme btn-sm fs-11px py-2 w-140px d-flex align-items-center justify-content-center">
						<Icon icon="material-symbols-light:add" className="fs-22px me-1 ms-n3 my-n3" />
						CREATE ORDERS
					</a>
				</div>
			</div>
			
			<div className="mb-md-4 mb-3 d-md-flex">
				<div className="mt-sm-0 mt-2 me-2"><a href="#/" className="text-body text-decoration-none d-flex align-items-center"><Icon icon="material-symbols-light:download-sharp" className="fs-20px opacity-5 me-2 my-n1" /> Export</a></div>
				<div className="ms-md-4 mt-md-0 mt-2 dropdown-toggle">
					<a href="#/" data-bs-toggle="dropdown" className="text-body text-decoration-none">More Actions</a>
					<div className="dropdown-menu">
						<a className="dropdown-item" href="#/">Action</a>
						<a className="dropdown-item" href="#/">Another action</a>
						<a className="dropdown-item" href="#/">Something else here</a>
						<div role="separator" className="dropdown-divider"></div>
						<a className="dropdown-item" href="#/">Separated link</a>
					</div>
				</div>
			</div>
			
			<Card>
				<ul className="nav nav-tabs nav-tabs-v2 px-2 small text-uppercase mb-4">
					<li className="nav-item me-4"><a href="#allTab" className="nav-link active px-2 py-2" data-bs-toggle="tab">All</a></li>
					<li className="nav-item me-4"><a href="#publishedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Unfulfilled</a></li>
					<li className="nav-item me-4"><a href="#expiredTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Unpaid</a></li>
					<li className="nav-item me-4"><a href="#deletedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Open</a></li>
					<li className="nav-item me-4"><a href="#deletedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Closed</a></li>
					<li className="nav-item me-4"><a href="#deletedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Local delivery</a></li>
				</ul>
				<div className="tab-content">
					<div className="tab-pane fade show active" id="allTab">
						<div className="input-group mb-4">
							<div className="flex-fill position-relative">
								<div className="input-group">
									<input type="text" className="form-control ps-35px" placeholder="Filter orders" />
									<div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0" style={{ zIndex: 1020 }}>
										<i className="fa fa-search opacity-5"></i>
									</div>
								</div>
							</div>
							<button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"><span className="d-none d-md-inline">Payment Status</span><span className="d-inline d-md-none"><i className="fa fa-credit-card"></i></span> &nbsp;</button>
							<div className="dropdown-menu">
								<a className="dropdown-item" href="#/">Action</a>
								<a className="dropdown-item" href="#/">Another action</a>
								<a className="dropdown-item" href="#/">Something else here</a>
								<div role="separator" className="dropdown-divider"></div>
								<a className="dropdown-item" href="#/">Separated link</a>
							</div>
							<button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"><span className="d-none d-md-inline">Fulfillment status</span><span className="d-inline d-md-none"><i className="fa fa-check"></i></span>  &nbsp;</button>
							<div className="dropdown-menu dropdown-menu-end">
								<a className="dropdown-item" href="#/">Action</a>
								<a className="dropdown-item" href="#/">Another action</a>
								<a className="dropdown-item" href="#/">Something else here</a>
								<div role="separator" className="dropdown-divider"></div>
								<a className="dropdown-item" href="#/">Separated link</a>
							</div>
						</div>
						
						<div className="table-responsive">
							<table className="table table-hover text-nowrap small mb-4">
								<thead>
									<tr className="text-uppercase">
										<th></th>
										<th>Order</th>
										<th>Date</th>
										<th>Customer</th>
										<th>Total</th>
										<th>Payment status</th>
										<th>Fulfillment status</th>
										<th>Items</th>
										<th>Delivery method</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product1" />
												<label className="form-check-label" htmlFor="product1"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1950</Link></td>
										<td className="align-middle">Thu 26 Nov, 12:23pm</td>
										<td className="align-middle">Amanda Lee</td>
										<td className="align-middle">$398.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED</span></td>
										<td className="align-middle">3 items</td>
										<td className="align-middle">Free shipping</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product2" />
												<label className="form-check-label" htmlFor="product2"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1949</Link></td>
										<td className="align-middle">Thu 26 Nov, 11:54am</td>
										<td className="align-middle">Leonard Oii</td>
										<td className="align-middle">$496.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED</span></td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Local pickup</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product3" />
												<label className="form-check-label" htmlFor="product3"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1948</Link></td>
										<td className="align-middle">Thu 25 Nov, 11:54pm</td>
										<td className="align-middle">John Doe</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING</span></td>
										<td className="align-middle"><span className="badge bg-yellow bg-opacity-15 text-yellow py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED</span></td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product4" />
												<label className="form-check-label" htmlFor="product4"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1947</Link></td>
										<td className="align-middle">Thu 25 Nov, 11:53pm</td>
										<td className="align-middle">Terry Ng</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING</span></td>
										<td className="align-middle"><span className="badge bg-yellow bg-opacity-15 text-yellow py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED</span></td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product5" />
												<label className="form-check-label" htmlFor="product5"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1946</Link></td>
										<td className="align-middle">Thu 25 Nov, 11:52pm</td>
										<td className="align-middle">Terry Ng</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING</span></td>
										<td className="align-middle"><span className="badge bg-yellow bg-opacity-15 text-yellow py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED</span></td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product6" />
												<label className="form-check-label" htmlFor="product6"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1945</Link></td>
										<td className="align-middle">Thu 24 Nov, 2:43pm</td>
										<td className="align-middle">Lelouch Wong</td>
										<td className="align-middle">$900.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-primary bg-opacity-15 text-primary py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> READY FOR PICKUP</span></td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Local pickup</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product7" />
												<label className="form-check-label" htmlFor="product7"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1944</Link></td>
										<td className="align-middle">Thu 23 Nov, 2:43pm</td>
										<td className="align-middle">Cynthia Ting</td>
										<td className="align-middle">$625.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-primary bg-opacity-15 text-primary py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> READY FOR DELIVERY</span></td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Local pickup</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product8" />
												<label className="form-check-label" htmlFor="product8"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1943</Link></td>
										<td className="align-middle">Thu 23 Nov, 11:59am</td>
										<td className="align-middle">Richard Leong</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PARTIALLY REFUNDED</span></td>
										<td className="align-middle"><span className="badge bg-danger bg-opacity-15 text-danger py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PARTIALLY FULFILLED</span></td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product9" />
												<label className="form-check-label" htmlFor="product9"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1942</Link></td>
										<td className="align-middle">Thu 22 Nov, 8:12am</td>
										<td className="align-middle">Clement Tang</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED</span></td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product10" />
												<label className="form-check-label" htmlFor="product10"></label>
											</div>
										</td>
										<td className="align-middle"><Link to="/pages/order-details">#1941</Link></td>
										<td className="align-middle">Thu 22 Nov, 7:42am</td>
										<td className="align-middle">Richard Leong</td>
										<td className="align-middle">$195.00</td>
										<td className="align-middle"><span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID</span></td>
										<td className="align-middle"><span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center"><i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED</span></td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product11" />
												<label className="form-check-label" htmlFor="product11"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1942</Link>
										</td>
										<td className="align-middle">Fri 23 Nov, 8:15am</td>
										<td className="align-middle">Sarah Connor</td>
										<td className="align-middle">$250.00</td>
										<td className="align-middle">
											<span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED </span>
										</td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Standard</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product12" />
												<label className="form-check-label" htmlFor="product12"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1943</Link>
										</td>
										<td className="align-middle">Sat 24 Nov, 9:30am</td>
										<td className="align-middle">John Doe</td>
										<td className="align-middle">$120.00</td>
										<td className="align-middle">
											<span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">3 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product13" />
												<label className="form-check-label" htmlFor="product13"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1944</Link>
										</td>
										<td className="align-middle">Sun 25 Nov, 10:00am</td>
										<td className="align-middle">Jane Smith</td>
										<td className="align-middle">$310.00</td>
										<td className="align-middle">
											<span className="badge bg-danger bg-opacity-15 text-danger py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> CANCELLED </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Standard</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product14" />
												<label className="form-check-label" htmlFor="product14"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1945</Link>
										</td>
										<td className="align-middle">Mon 26 Nov, 11:45am</td>
										<td className="align-middle">Michael Johnson</td>
										<td className="align-middle">$175.00</td>
										<td className="align-middle">
											<span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED </span>
										</td>
										<td className="align-middle">4 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product15" />
												<label className="form-check-label" htmlFor="product15"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1946</Link>
										</td>
										<td className="align-middle">Tue 27 Nov, 12:20pm</td>
										<td className="align-middle">Emily Davis</td>
										<td className="align-middle">$80.00</td>
										<td className="align-middle">
											<span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Standard</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product16" />
												<label className="form-check-label" htmlFor="product16"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1947</Link>
										</td>
										<td className="align-middle">Wed 28 Nov, 1:05pm</td>
										<td className="align-middle">David Brown</td>
										<td className="align-middle">$230.00</td>
										<td className="align-middle">
											<span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED </span>
										</td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product17" />
												<label className="form-check-label" htmlFor="product17"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1948</Link>
										</td>
										<td className="align-middle">Thu 29 Nov, 2:30pm</td>
										<td className="align-middle">Olivia Martin</td>
										<td className="align-middle">$150.00</td>
										<td className="align-middle">
											<span className="badge bg-danger bg-opacity-15 text-danger py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> CANCELLED </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">3 items</td>
										<td className="align-middle">Standard</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product18" />
												<label className="form-check-label" htmlFor="product18"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1949</Link>
										</td>
										<td className="align-middle">Fri 30 Nov, 3:45pm</td>
										<td className="align-middle">Sophia White</td>
										<td className="align-middle">$95.00</td>
										<td className="align-middle">
											<span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED </span>
										</td>
										<td className="align-middle">2 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product19" />
												<label className="form-check-label" htmlFor="product19"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1950</Link>
										</td>
										<td className="align-middle">Sat 1 Dec, 4:20pm</td>
										<td className="align-middle">James Black</td>
										<td className="align-middle">$110.00</td>
										<td className="align-middle">
											<span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">1 item</td>
										<td className="align-middle">Standard</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product20" />
												<label className="form-check-label" htmlFor="product20"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1951</Link>
										</td>
										<td className="align-middle">Sun 2 Dec, 5:35pm</td>
										<td className="align-middle">Charlotte Green</td>
										<td className="align-middle">$300.00</td>
										<td className="align-middle">
											<span className="badge bg-success bg-opacity-15 text-success py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PAID </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> FULFILLED </span>
										</td>
										<td className="align-middle">3 items</td>
										<td className="align-middle">Express</td>
									</tr>
									<tr>
										<td className="w-10px align-middle">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product21" />
												<label className="form-check-label" htmlFor="product21"></label>
											</div>
										</td>
										<td className="align-middle">
											<Link to="/pages/order-details">#1952</Link>
										</td>
										<td className="align-middle">Mon 3 Dec, 6:50pm</td>
										<td className="align-middle">Henry King</td>
										<td className="align-middle">$220.00</td>
										<td className="align-middle">
											<span className="badge bg-warning bg-opacity-15 text-warning py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> PENDING </span>
										</td>
										<td className="align-middle">
											<span className="badge bg-white bg-opacity-15 text-white text-opacity-75 py-4px px-2 fs-9px d-inline-flex align-items-center">
												<i className="fa fa-circle opacity-5 fs-4px fa-fw me-2"></i> UNFULFILLED </span>
										</td>
										<td className="align-middle">4 items</td>
										<td className="align-middle">Standard</td>
									</tr>
								</tbody>
							</table>
						</div>
						
						<div className="d-md-flex align-items-center">
							<div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
								Showing 1 to 20 of 57 entries
							</div>
							<ul className="pagination mb-0 justify-content-center">
								<li className="page-item disabled"><a className="page-link" href="#/">Previous</a></li>
								<li className="page-item"><a className="page-link" href="#/">1</a></li>
								<li className="page-item active"><a className="page-link" href="#/">2</a></li>
								<li className="page-item"><a className="page-link" href="#/">3</a></li>
								<li className="page-item"><a className="page-link" href="#/">4</a></li>
								<li className="page-item"><a className="page-link" href="#/">5</a></li>
								<li className="page-item"><a className="page-link" href="#/">6</a></li>
								<li className="page-item"><a className="page-link" href="#/">Next</a></li>
							</ul>
						</div>
					</div>
				</div>
			</Card>
		</div>
	)
}

export default PagesOrders;